<template>
  <div
    v-if="initialized"
    class="ziggu_lg_horizontal"
  >
    <InvoiceOverdueBanner
      v-if="billing_current_client && billing_current_client.attributes.invoice_overdue"
      :billing="billing_current_client"
    />
    <NavbarDesktopClientHorizontal
      @toggleNotificationSidebar="show_notification_sidebar = !show_notification_sidebar"
    />
    <NavbarDesktopClientHorizontalOverview v-if="is_overview_route" />
    <NavbarDesktopClientHorizontalSecondary v-else />
    <div
      v-if="current_project && current_project.attributes.skip_customer"
      id="information_banner"
    >
      <div
        class="has-background-primary-light has-text-color-primary has-text-weight-medium flex items-center justify-center py-4"
      >
        <span v-if="$flipper.enabled($FT.TEMPLATE_PROJECTS)">
          <FontAwesomeIcon
            class="mr-2"
            :icon="['far', 'memo']"
          />
          {{ $t('project.labels.youAreEditingTemplateProject') }}
        </span>
        <span v-else>
          <ButtonUpsell feature="project_templates">
            {{ $t('upsell.project_templates.cta2') }}
          </ButtonUpsell>
        </span>
      </div>
    </div>
    <div
      v-else-if="current_project && !current_project.attributes.activated"
      id="information_banner"
    >
      <div
        class="has-background-primary-light has-text-color-primary has-text-weight-medium flex items-center justify-center py-4"
      >
        <FontAwesomeIcon
          class="mr-2"
          icon="toggle-off"
        />
        {{ $t('project.labels.projectIsDeactivated') }}
      </div>
    </div>
    <main
      id="page"
      class="relative flex"
    >
      <div class="w-full overflow-y-auto">
        <div class="container h-full w-full p-5">
          <router-view class="content-wrapper" />
        </div>
      </div>
      <TheNotificationsSidebar v-show="show_notification_sidebar" />
    </main>
  </div>
  <b-loading
    v-else
    :is-full-page="true"
    :model-value="!initialized"
  />
</template>

<script>
import NavbarDesktopClientHorizontalOverview from '@/app/_employees/components/navbar/TheNavbarDesktopClientHorizontalOverview.vue';
import NavbarDesktopClientHorizontal from '@/app/_employees/components/navbar/TheNavbarDesktopClientHorizontal.vue';
import NavbarDesktopClientHorizontalSecondary from '@/app/_employees/components/navbar/TheNavbarDesktopClientHorizontalSecondary.vue';
import InvoiceOverdueBanner from '@/app/_employees/components/InvoiceOverdueBanner.vue';
import profile_mixin from '@/app/util/profile_mixin';
import { mapGetters } from 'vuex';
import { ROUTES_EMPLOYEE_OVERVIEWS, ROUTES_EMPLOYEES } from '@/app/data/route_constants';
import TheNotificationsSidebar from '@/app/shared_components/navbar/notifications/TheNotificationsSidebar.vue';
import SIDEBAR_NOTIFICATIONS from '@/app/data/sidebar_constants';

export default {
  name: 'Employee',
  components: {
    TheNotificationsSidebar,
    NavbarDesktopClientHorizontalOverview,
    NavbarDesktopClientHorizontal,
    NavbarDesktopClientHorizontalSecondary,
    InvoiceOverdueBanner,
  },
  mixins: [profile_mixin],
  computed: {
    ...mapGetters(['current_client', 'current_project', 'sidebar_type']),
    is_overview_route() {
      return (
        Object.values(ROUTES_EMPLOYEE_OVERVIEWS).includes(this.$route.name) ||
        this.$route.name === ROUTES_EMPLOYEES.CLIENT_TICKETS_SHOW
      );
    },
    show_notification_sidebar() {
      return this.sidebar_type === SIDEBAR_NOTIFICATIONS;
    },
  },

  async created() {
    await this.initProfile();
  },
};
</script>
<style>
.content-wrapper > div {
  padding-bottom: 3rem;
}
</style>
